import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrush = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_15_7894",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_15_7894)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.16106 16.9232C4.68425 16.9232 4.21279 16.8185 3.74668 16.6091C3.28043 16.3996 2.89189 16.1197 2.58105 15.7693C2.89939 15.6785 3.20064 15.4853 3.4848 15.1899C3.76897 14.8946 3.91105 14.5002 3.91105 14.0066C3.91105 13.4242 4.11272 12.9314 4.51605 12.5282C4.91939 12.1249 5.41217 11.9232 5.99439 11.9232C6.57675 11.9232 7.06953 12.1249 7.47272 12.5282C7.87605 12.9314 8.07772 13.4242 8.07772 14.0066C8.07772 14.8087 7.79217 15.4953 7.22106 16.0664C6.64981 16.6376 5.96314 16.9232 5.16106 16.9232ZM5.16106 15.6732C5.61939 15.6732 6.01175 15.51 6.33814 15.1837C6.66453 14.8573 6.82772 14.4649 6.82772 14.0066C6.82772 13.7705 6.74786 13.5725 6.58814 13.4128C6.42842 13.2531 6.2305 13.1732 5.99439 13.1732C5.75828 13.1732 5.56036 13.2531 5.40064 13.4128C5.24092 13.5725 5.16106 13.7705 5.16106 14.0066C5.16106 14.326 5.12286 14.6177 5.04647 14.8816C4.97008 15.1455 4.86939 15.3955 4.74439 15.6316C4.81383 15.6594 4.88328 15.6732 4.95272 15.6732H5.16106ZM9.58418 12.2918L7.72522 10.4328L14.8629 3.29511C15.0157 3.14234 15.2067 3.06248 15.4358 3.05553C15.665 3.04859 15.8629 3.12845 16.0296 3.29511L16.7219 3.98741C16.8886 4.15407 16.9719 4.34852 16.9719 4.57074C16.9719 4.79296 16.8886 4.98741 16.7219 5.15407L9.58418 12.2918Z",
			fill: "#152A58"
		})
	})]
});
export default SvgBrush;
